import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IMaterial } from '../models/materials';
import { IBasicResource } from '../models/basicResource';

@Injectable({
    providedIn: 'root'
})
export class BasicResourcesService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getBuildingBasicResources(buildingId: string): Observable<{has_error: boolean, message: string; data: IBasicResource[]}> {
        const url = environment.apiBaseUrl + endpoints.getBuildingBasicResources.replace(':buildingId', buildingId);

        return this.http.get<{has_error: boolean, message: string; data: IBasicResource[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    createBasicResource(buildingId: string, data: IMaterial): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.createBasicResource.replace(':buildingId', buildingId);

        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

    updateBasicResource(buildingId: string, materialId: string, data: IBasicResource): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.editBasicResource
            .replace(':buildingId', buildingId)
            .replace(':materialId', materialId+'');

        return this.http.put<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

    approveBuildingBasicResources(buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.approveBuildingBasicResources.replace(':buildingId', buildingId);

        return this.http.post<{has_error: boolean, message: string, data: any}>(url, {}).pipe(
            catchError(this.errorService.handleError)
        );
    }

    deleteResource(buildingId: string, materialId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.deleteBasicResource
            .replace(':buildingId', buildingId)
            .replace(':materialId', materialId);

        return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
}